// This file is automatically generated. Do not edit manually.

import { CustomerOrderProfitabilityAnalysisDto } from "src/api/generated/erp/sales/customerOrder/profitability/model/customerOrderProfitabilityAnalysisDto";
import { CustomerOrderProfitabilityPlanLineInput } from "src/api/generated/erp/sales/customerOrder/profitability/model/customerOrderProfitabilityPlanLineInput";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace CustomerOrderProfitabilityAnalysisApi {
	export async function getAnalysis(args: {
		customerOrderId: number;
	}): Promise<CustomerOrderProfitabilityAnalysisDto> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrder/profitability/getAnalysis",
			method: "POST",
			data: {
				customerOrderId: args.customerOrderId,
			},
		});
		return response as CustomerOrderProfitabilityAnalysisDto;
	}

	export async function savePlanLines(args: {
		customerOrderId: number;
		updates: Array<CustomerOrderProfitabilityPlanLineInput>;
	}): Promise<CustomerOrderProfitabilityAnalysisDto> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrder/profitability/savePlanLines",
			method: "POST",
			data: {
				customerOrderId: args.customerOrderId,
				updates: args.updates,
			},
		});
		return response as CustomerOrderProfitabilityAnalysisDto;
	}
}
